import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DataBaseProvider } from '../../providers/data-base/data-base';
import { Observable } from 'rxjs';
import { BillPreviewPage } from '../bill-preview/bill-preview';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
import * as moment from 'moment';

/**
 * Generated class for the ListBillingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-list-billing',
  templateUrl: 'list-billing.html',
})
export class ListBillingPage {
  billList: Observable<any>;
  userKey: string;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public $db: DataBaseProvider,
    public $auth: AuthServiceProvider) {

  }

  ionViewDidLoad() {
    this.userKey = this.navParams.get('userKey');
    this.billList = this.$db.getBillList(this.userKey ? this.userKey : this.$auth.getCurrentUserKey()).map((bills: any[]) => {
      // remove the elements with no timeStamp
      bills = bills.filter(bills => bills.timeStamp);
      bills = bills.sort((bill1, bill2) => {
        return bill1.timeStamp.seconds > bill2.timeStamp.seconds ? -1 : 1;
      });
      return bills;
    });
  }

  goToBill(itemKey) {
    this.navCtrl.push(BillPreviewPage, { billKey: itemKey, mode: 'PREVIEW' });
  }

  convertTimeStampToDate(timeStamp) {
    return timeStamp ? moment.unix(timeStamp.seconds).format('DD MMM YYYY, hh:mm A') : '';
  }



}



// WEBPACK FOOTER //
// ./src/pages/list-billing/list-billing.ts